import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '@services/auth.service';

@Injectable({
  providedIn: 'root',
})
export class LoginGuard  {
  loading: boolean = false;
  constructor(
    private readonly router: Router,
    private readonly authService: AuthService
  ) {
    this.authService.loading$.subscribe(isLoading => {
      this.loading = isLoading;
    });
  }

  canActivate(): Observable<boolean> | Promise<boolean> | boolean {
    setTimeout(() => {
      if (this.authService.isAuth()) {
        this.router.navigate(['home']);
      }
      return false;
    }, 1000);

    return true;
  }
}
